import { FIELD_TYPES } from '@atlassian/jira-polaris-domain-field/src/field-types/index.tsx';
import type { Field } from '@atlassian/jira-polaris-domain-field/src/field/types.tsx';

export const isFieldInsights = (field: Field) => field.type === FIELD_TYPES.INSIGHTS;

export const roundOneDecimal = (value: number) => Math.round(value * 10) / 10;
